"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Droplet, Scale, Leaf, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestroAceite() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: bottleRef,
    isVisible: bottleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = [{
    icon: Scale,
    title: "Acidez Mínima",
    description: "Nuestro aceite mantiene una acidez inferior al 0.3%, garantizando pureza y calidad excepcional en cada gota."
  }, {
    icon: Droplet,
    title: "Sabor Equilibrado",
    description: "Un perfil organoléptico armonioso que combina notas frutales con un amargor y picor suaves, ideal para cualquier plato."
  }, {
    icon: Leaf,
    title: "Sostenibilidad",
    description: "Cultivamos con respeto al medio ambiente, utilizando prácticas agrícolas sostenibles que protegen nuestra tierra para futuras generaciones."
  }, {
    icon: MapPin,
    title: "Trazabilidad Total",
    description: "Desde el olivar hasta tu mesa, cada botella cuenta con trazabilidad completa, asegurando transparencia y origen verificado."
  }];
  return <section id="nuestro-aceite" ref={sectionRef} className="section bg-background px-4 overflow-hidden py-12 md:py-9 lg:py-12">
      <div className="container">
        <div className={`text-center mb-10 transition-all duration-1000 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-4">
            Nuestro Aceite
          </h2>
          <p className="font-sans text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">
            Un aceite de oliva virgen extra que refleja tradición, calidad y el
            carácter único de nuestro olivar
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-8 lg:gap-12 items-start">
          <div className="space-y-6" data-index={0}>
            {benefits.slice(0, 2).map((benefit, i) => {
            const Icon = benefit.icon;
            return <Card key={i} data-index={i} className={`transition-all duration-500 shadow-none ${sectionVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`} style={{
              transitionDelay: `${i * 150}ms`
            }}>
                  <CardContent className="flex gap-4 items-start">
                    <div className="shrink-0 mt-1">
                      <div className="bg-accent/20 p-3 rounded-lg">
                        <Icon className="size-6 text-accent-foreground" />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg text-foreground mb-2">
                        {benefit.title}
                      </h3>
                      <p className="font-sans text-muted-foreground text-sm leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>;
          })}
          </div>

          <div ref={bottleRef} className={`flex justify-center items-center lg:mx-8 transition-all duration-1000 ${bottleVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
            <div className="relative w-64 md:w-80 lg:w-96">
              <div className="absolute inset-0 bg-transparent blur-3xl rounded-lg" />
              <img src="https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/openart-021771537057958e0570d30189b68d5608c0b11774ff85b25b54b_0_1771537084983_a09d0d3f.png" alt="Botella de Aceite Paco y Herminia" className="hero-img relative" />
            </div>
          </div>

          <div className="space-y-6" data-index={1}>
            {benefits.slice(2, 4).map((benefit, i) => {
            const Icon = benefit.icon;
            return <Card key={i + 2} data-index={i} className={`transition-all duration-500 shadow-none ${sectionVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`} style={{
              transitionDelay: `${(i + 2) * 150}ms`
            }}>
                  <CardContent className="flex gap-4 items-start">
                    <div className="shrink-0 mt-1">
                      <div className="bg-accent/20 p-3 rounded-lg">
                        <Icon className="size-6 text-accent-foreground" />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg text-foreground mb-2">
                        {benefit.title}
                      </h3>
                      <p className="font-sans text-muted-foreground text-sm leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>

        <div className={`flex justify-center mt-16 transition-all duration-1000 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        transitionDelay: "800ms"
      }}>
          <Badge variant="outline" className="px-6 py-2 text-sm font-medium border-primary text-primary bg-primary/5 rounded-lg">
            Disponible exclusivamente en tiendas delicatessen y catas — Sin
            venta online
          </Badge>
        </div>
      </div>
    </section>;
}